<template>
    <div class="tsa-customTable2">
        <el-table
            ref="customizeTableRef"
            :key="customizekey"
            :row-key="getRowKey"
            :data="data"
            style="width: 100%;"
            :height="height"
            :max-height="maxHeight"
            :stripe="stripe"
            :header-row-style="headerRowStyle"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
            :span-method="spanMethod"
            :row-class-name="rowClassName"
            :selectable="selectable"
            @cell-mouse-leave="cellMouseLeave"
            @cell-mouse-enter="cellMouseEnter"
            @header-dragend="changeColWidth"
            @select="select"
            @selection-change="selectionChange"
            @select-all="selectAllTable"
            @sort-change="sortChange"
            @row-click="rowClick"
            :border="border"
            :show-header="showHeader"
        >
            <slot />
            <template slot="empty" v-if="data.length === 0 && $slots.tsaTableEmpty">
                <div class="tsa-el-table-empty">
                    <slot name="tsaTableEmpty">
                        <!-- <TsaTableEmpty /> -->
                    </slot>
                </div>
            </template>
        </el-table>
        <div class="table-loading" v-show="loading">
            <!-- <img src="" alt=""> -->
            <span class="el-icon-loading"></span>
            <p>拼命加载中</p>
        </div>
    </div>
</template>

<script>
import { debounce, debounce2 } from '@/common/copyright/utils'
import tableConfig from '@/config/copyright/tableConfig'
export default {
    name: 'TsaTable',
    props: {
        customizekey: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        stripe: {
            type: Boolean,
            default: false
        },
        height: [String, Number],
        maxHeight: [String, Number],
        border: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        selectable: {
            type: Function,
            default: () => {}
        },
        spanMethod: {
            type: Function,
            default: () => {}
        },
        rowClassName: {
            type: Function,
            default: () => {}
        },
        customRowKey: {
            type: String,
            default: ''
        },
        // 是否开启上拉加载
        isMoreLoad: {
            type: Boolean,
            default: false
        },
        // 是否处于加载完成状态
        finished: {
            type: Boolean,
            default: false
        },
        // 是否处于正在加载更多状态
        loadingMore: {
            type: Boolean,
            default: false
        },
        showHeader: {
            type: Boolean,
            default: true
        }
    },
    components: {
        // TsaTableEmpty
    },
    watch: {
        data () {
            this.doLayout();
        }
    },
    data () {
        return {
            clickCount: 0,
            timer: null,
            callNow: true
        }
    },
    mounted () {
        this.$nextTick(() => {
            let children = this.$refs.customizeTableRef.$el.children
            let parent = this.$refs.customizeTableRef.$el.parentNode
            for (let i = 0; i < children.length; i++) {
                let classList = Array.from(children[i].classList)
                if (classList.indexOf('el-table__header-wrapper') > -1) {
                    parent.lastElementChild.style.top = children[i].offsetHeight + 'px'
                }
            }
        })
        
        if (this.isMoreLoad) {
            let el = this.$refs.customizeTableRef.$el;
            this.target = el.querySelector(".el-table__body-wrapper");
            this.target && this.target.addEventListener("scroll", this.scrollFun)
        }
    },
    beforeDestroy () {
        if (this.isMoreLoad) {
            this.target && this.target.removeEventListener("scroll", this.scrollFun)
        }
    },
    methods: {
        // 表格滚动到顶部
        scrollTo (val) {
            this.target.scrollTop = val
        },
        scrollFun: debounce(function(e) {
            if (this.loadingMore || this.finished) return;
            let element = e.target
            // element.scrollHeight 获取元素内容的总高度，包括溢出的部分
            // element.scrollTop 获取元素滚动的距离
            // element.clientHeight 获取元素可视区域的高度
            this.$emit('on-scroll')
            if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                // console.log('到底部了')
                this.$emit('on-loadMore')
            } else {
                // console.log('没到底部')
            }
        }, 200),
        getRowKey (row) {
            return this.customRowKey ? row[this.customRowKey] : null
        },
        getSelection () {
            return this.$refs.customizeTableRef.selection
        },
        clearSelection () {
            this.$refs.customizeTableRef.clearSelection();
        },
        // 重绘布局
        doLayout () {
            this.$refs.customizeTableRef.doLayout();
        },
        headerRowStyle () {
            return tableConfig['headerRowStyle']
        },
        headerCellStyle ({ column, columnIndex }) {
            return column.type === 'selection' && columnIndex === 0 ? tableConfig['selectionHeaderCellStyle'] : tableConfig['headerCellStyle']
        },
        cellStyle ({ column, columnIndex }) {
            return column.type === 'selection' && columnIndex === 0 ? tableConfig['selectioncellStyle'] : tableConfig['cellStyle']
        },
        cellMouseLeave (row, column, cell, event) {
            this.$emit('cell-mouse-leave', {
                row, column, cell, event
            })
        },
        cellMouseEnter (row, column, cell, event) {
            this.$emit('cell-mouse-enter', {
                row, column, cell, event
            })
        },
        // 表格拖拽
        changeColWidth (newWidth, oldWidth, column, event) {
            tableConfig['changeColWidth'](newWidth, oldWidth, column, event).then(res => {
                this.$nextTick(()=>{
                    //动态表格加载完之后,重新布局                             
                    this.doLayout();
                });
            })
            
        },
        // 选中
        select (array, row) {
            this.$set(row, 'choosed', !row.choosed)
            this.$emit('select', array, row)
        },
        // 全选
        selectAllTable (array) {
            this.$emit('select-all', array)
        },
        // 只要有选中就会触发
        selectionChange (selection) {
            this.$emit('selection-change', selection)
        },
        toggleRowSelection (row, boolean) {
            this.$refs.customizeTableRef.toggleRowSelection(row, boolean);
        },
        toggleRowExpansion (row, boolean) {
            this.$refs.customizeTableRef.toggleRowExpansion(row, boolean);
        },
        sortChange ({ column, prop, order }) {
            // prop: string, order: string
            console.log({ column, prop, order })
            this.$emit('sort-change', { column, prop, order })
        },
        rowClick (row, column, event) {
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'SPAN') {  
                // 阻止行点击事件  
                return;  
            }
            this.clickCount++;
            // 判断点击次数，如果是首次点击，则启动延时器
            if (this.clickCount === 1) {
                this.timer = setTimeout(() => {
                    // 执行单击操作
                    this.$emit('row-click', { row, column, event })
                    clearTimeout(this.timer);
                    this.timer = null
                    this.resetClickCount();
                }, 300); // 设置延时时间，单位为毫秒
            } else {
            // 如果点击次数大于1，则说明是双击操作，清除延时器，并执行双击操作
                clearTimeout(this.timer);
                this.timer = null
                this.$emit('row-dblclick', { row, column, event })
                this.resetClickCount();
            }
        },
        resetClickCount() {
            // 重置点击计数器
            this.clickCount = 0;
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-customTable2 {
        position: relative;
        width: 100%;
        height: 100%;
        /deep/.el-table {
            height: 100%;
            &.el-table--border {
                border: 0;
                // 兼容safari列头与td对不齐问题
                .el-table__header, .el-table__body, .el-table__footer{
                    width:100% !important;
                    table-layout: fixed !important;
                }
                .el-table__header {
                    tr {
                        th {
                            border-right: 1px solid #FFFFFF!important;
                            &.el-table__cell {
                                &.gutter {
                                    &:last-of-type {
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                }
                &::after {
                    display: none;
                }
            }
            &::before {
                display: none!important;
            }
            
            &.el-table--enable-row-hover {
                .el-table__body {
                    tr {
                        &:hover {
                            // cursor: pointer;
                            >td.el-table__cell {
                                background-color: #F8F9FC;
                            }
                        }
                    }
                    
                }
            }
            .cell {
                width: 100%;
                padding: 0;
            }
            td {
                color: #000000;
            }
            .el-table__body-wrapper {
                .el-table__body {
                    .el-table__row {
                        td {
                            .cell {
                                width: 100%!important;
                            }
                        }
                    }
                }
                .el-table__empty-block {
                    width: 100%!important;
                }
            }
            .el-checkbox {
                &.is-checked {
                    .el-checkbox__inner {
                        background-color: #2468F2;
                        border-color: #2468F2;
                    }
                }
                .el-checkbox__input {
                    &.is-indeterminate {
                        .el-checkbox__inner {
                            background-color: #2468F2;
                            border-color: #2468F2;
                        }
                    }
                }
            }
        }
        .el-table__fixed-right::before, .el-table::before {
            height: 0;
        }
        .table-loading {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: #FFFFFF;
            z-index: 3;
            span {
                font-size: 20px;
                color: #409eff;
                margin-bottom: 5px;
            }
            p {
                color: #409eff;
                margin: 3px 0;
                font-size: 14px;
            }
        }
    }
</style>